var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ant-design:code-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.75 2.25H2.25C1.97344 2.25 1.75 2.47344 1.75 2.75V14.25C1.75 14.5266 1.97344 14.75 2.25 14.75H13.75C14.0266 14.75 14.25 14.5266 14.25 14.25V2.75C14.25 2.47344 14.0266 2.25 13.75 2.25ZM8.01719 8.59531L5.01719 11.1109C4.93594 11.1797 4.8125 11.1219 4.8125 11.0156V10.0359C4.8125 10 4.82969 9.96406 4.85781 9.94063L6.57344 8.5L4.85781 7.05937C4.84345 7.04803 4.83189 7.03353 4.82404 7.01701C4.81618 7.00048 4.81223 6.98236 4.8125 6.96406V5.98438C4.8125 5.87812 4.93594 5.82031 5.01719 5.88906L8.01719 8.40312C8.07812 8.45312 8.07812 8.54531 8.01719 8.59531ZM11.1875 11.0156C11.1875 11.0844 11.1344 11.1406 11.0703 11.1406H8.17969C8.11562 11.1406 8.0625 11.0844 8.0625 11.0156V10.2656C8.0625 10.1969 8.11562 10.1406 8.17969 10.1406H11.0703C11.1344 10.1406 11.1875 10.1969 11.1875 10.2656V11.0156Z",
    fill: "white",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeEditor);
export default __webpack_public_path__ + "static/media/CodeEditor.05d3fa6a3e273e8d87c2064dd3a19491.svg";
export { ForwardRef as ReactComponent };